import React from "react";

export type ToastState = {
  id: number;
  message: string;
} | null;

export function Toast({ toast }: { toast: ToastState }) {
  if (!toast) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: "absolute",
        left: "50%",
        bottom: 24,
        transform: "translateX(-50%)",
        zIndex: 100,
        pointerEvents: "none",
        background: "rgba(15, 15, 18, 0.94)",
        color: "var(--fg)",
        border: "1px solid #2a2a30",
        borderRadius: 6,
        padding: "8px 12px",
        fontSize: 12,
        fontWeight: 500,
        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.35)",
      }}
    >
      {toast.message}
    </div>
  );
}
